import { G } from '@mobily/ts-belt';
import { isAxiosError, type AxiosError, type AxiosResponse } from 'axios';
export type SessionRequestParameters = {
  user: {
    login: string;
    password: string;
  };
  scope: 'default';
};
export type LoginAuthResponse = {
  redirect_url: string;
};
export type LoginResponseError = {
  error_message: string;
  recaptcha?: boolean;
};
export interface LoginAuthError extends AxiosError {
  response: AxiosResponse<LoginResponseError>;
}
const isLoginAuthResponseError = (response: AxiosResponse): response is LoginAuthError['response'] => G.isString(response.data.error_message);
export const isLoginAuthError = (error: unknown): error is LoginAuthError => isAxiosError(error) && G.isObject(error.response) && isLoginAuthResponseError(error.response);
type PasswordlessLoginErrorResponse = {
  error: {
    message: string;
    code?: string;
  };
};
export interface PasswordlessLoginAuthError extends AxiosError {
  response: AxiosResponse<PasswordlessLoginErrorResponse>;
}
const isPasswordlessLoginAuthResponseError = (response: AxiosResponse): response is PasswordlessLoginAuthError['response'] => {
  return G.isObject(response.data) && G.isObject(response.data.error);
};
export const isPasswordlessLoginAuthError = (error: unknown): error is PasswordlessLoginAuthError => isAxiosError(error) && G.isObject(error.response) && isPasswordlessLoginAuthResponseError(error.response);
type PasskeyLoginErrorResponse = {
  error: {
    message: string;
    code: string;
  };
};
export interface PasskeyLoginAuthError extends AxiosError {
  response: AxiosResponse<PasskeyLoginErrorResponse>;
}
const isPasskeyLoginAuthResponseError = (response: AxiosResponse): response is PasskeyLoginAuthError['response'] => G.isObject(response.data) && G.isObject(response.data.error);
export const isPasskeyLoginAuthError = (error: unknown): error is PasskeyLoginAuthError => isAxiosError(error) && G.isObject(error.response) && isPasskeyLoginAuthResponseError(error.response);